import { toSocialLinks } from "./adapter";
import DataService from "./dataService";

export default class {
  constructor({ dataService } = {}) {
    this.dataService = dataService || new DataService();
  }

  getSocialLinks(data) {
    return this.dataService
      .getSocialLinks(data)
      .then((response) => {
        return toSocialLinks(response);
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }
}
